import { MODELS } from '../Lib/constants';

export const countUri = ({ id, model, filter }) => ({
  query: {
    id,
    addOnFilter: filter,
  },
  fetchCount: true,
  model,
});

export const getSMSOfferListUri = ({ navigation }) => {
  let addOnFilter = {};
  const filters = navigation?.state?.params?.filters;

  if (filters?.username) {
    addOnFilter = { name: filters.username?.value?.username };
  }

  if (filters?.checkDate) {
    const { from, to } = filters?.checkDate?.value;
    addOnFilter = { ...addOnFilter, onDate: { $gte: from, $lte: to } };
  }

  return {
    query: {
      id: 'listAll',
      addOnFilter,
    },
    aggregate: true,
    model: MODELS.SMSOfferCount,
  };
};

export const getMailOfferListUri = ({ navigation }) => {
  let addOnFilter = {};
  const filters = navigation?.state?.params?.filters;

  if (filters?.username) {
    addOnFilter = { name: filters.username?.value?.username };
  }

  if (filters?.checkDate) {
    const { from, to } = filters?.checkDate?.value;
    addOnFilter = { ...addOnFilter, onDate: { $gte: from, $lte: to } };
  }

  return {
    query: {
      id: 'listAll',
      addOnFilter,
    },
    aggregate: true,
    model: MODELS.MailOfferCount,
  };
};
